module.exports = __webpack_public_path__ + "img/2.a63334b7.png";